import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { grafikService } from '../../../services/grafikService';
import { toISODate } from '../../../utils/grafikHelpers';

/**
 * Modal: kopiuj tydzien z innego tygodnia.
 * Props: onClose(), onCopied()
 */
const CopyWeekModal = ({ onClose, onCopied }) => {
  const [fromDate, setFromDate] = useState(toISODate(new Date()));
  const [toDate, setToDate] = useState(toISODate(new Date()));
  const [overrideExisting, setOverrideExisting] = useState(false);
  const [busy, setBusy] = useState(false);

  const handleCopy = async () => {
    if (!fromDate || !toDate) {
      toast.error('Wybierz obie daty');
      return;
    }
    setBusy(true);
    try {
      const res = await grafikService.copyWeek({
        from_date: fromDate,
        to_date: toDate,
        override_existing: overrideExisting
      });
      const copied = res?.data?.copied ?? res?.data?.count ?? '';
      toast.success(`Skopiowano tydzien${copied !== '' ? ` (${copied} zmian)` : ''}`);
      onCopied && onCopied();
      onClose && onClose();
    } catch (err) {
      toast.error(err.message || 'Blad kopiowania tygodnia');
    } finally {
      setBusy(false);
    }
  };

  const inputStyle = {
    width: '100%', padding: '0.5rem',
    border: '1px solid var(--border)', borderRadius: '4px',
    backgroundColor: 'var(--card-bg)', color: 'var(--text)', fontSize: '0.9rem'
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1001
    }} onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div style={{
        backgroundColor: 'var(--card-bg)', borderRadius: '8px',
        width: '100%', maxWidth: '460px',
        border: '1px solid var(--border)', boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
      }}>
        <div style={{
          padding: '1rem 1.25rem', borderBottom: '1px solid var(--border)',
          backgroundColor: 'var(--bg)', display: 'flex', justifyContent: 'space-between', alignItems: 'center'
        }}>
          <h4 style={{ margin: 0, fontSize: '1rem', fontWeight: 600 }}>Kopiuj tydzien</h4>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', fontSize: '1.2rem', cursor: 'pointer' }}>
            &#x2715;
          </button>
        </div>
        <div style={{ padding: '1.25rem' }}>
          <div style={{ marginBottom: '0.75rem' }}>
            <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '0.25rem' }}>
              Z dnia (poniedzialek tygodnia zrodlowego)
            </label>
            <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} style={inputStyle} />
          </div>
          <div style={{ marginBottom: '0.75rem' }}>
            <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '0.25rem' }}>
              Do dnia (poniedzialek tygodnia docelowego)
            </label>
            <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} style={inputStyle} />
          </div>
          <div style={{ marginBottom: '0.75rem' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.85rem' }}>
              <input
                type="checkbox" checked={overrideExisting}
                onChange={(e) => setOverrideExisting(e.target.checked)}
              />
              Nadpisz istniejace zmiany w tygodniu docelowym
            </label>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem', paddingTop: '0.5rem' }}>
            <button onClick={onClose}
              style={{
                padding: '6px 12px',
                border: '1px solid var(--border)', backgroundColor: 'var(--card-bg)',
                color: 'var(--text-secondary)', cursor: 'pointer', fontSize: '12px'
              }}
            >Anuluj</button>
            <button onClick={handleCopy} disabled={busy}
              style={{
                padding: '6px 12px',
                backgroundColor: 'var(--info)', color: '#fff',
                border: 'none', cursor: 'pointer', fontSize: '12px', fontWeight: 600
              }}
            >{busy ? 'Kopiuje...' : 'Kopiuj'}</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CopyWeekModal;
